import React from 'react';
import PropTypes from 'prop-types';
import { Common } from '../../utils/common';

function EveryLeadCount({ href, count, title, prevCount, icon, colorClassName, invertChangeColor = false }) {
  function calculateChange(count, prevCount) {
    let changeIcon = '';
    if (count - prevCount === 0) {
      changeIcon = '';
    } else if (count > prevCount) {
      changeIcon = invertChangeColor ? 'fa-arrow-up text-danger' : 'fa-arrow-up text-success';
    } else {
      changeIcon = invertChangeColor ? 'fa-arrow-down text-success' : 'fa-arrow-down text-danger';
    }
    return changeIcon;
  }

  return (
    <a
      className={`every-lead-stats btn btn-default ${href ? '' : 'btn-non-clickable'}`}
      href={href}
    >
      <div className='every-lead-stats-header'>
        <span className={`every-lead-stats-count ${colorClassName}-total`}>
          {count ? Common.formatNumberWithCommas(count) : 0}
        </span>
        <span className={`every-lead-stats-icon fa ${icon}`} />
      </div>
      <div className='every-lead-stats-title'>{title}</div>
      <div className='every-lead-stats-change'>
        <span
          style={{ marginRight: '4px' }}
          className={`fa ${calculateChange(count, prevCount)}`}
        />
        <span>{prevCount ? Common.formatNumberWithCommas(prevCount) : 0}</span>
      </div>
      <div className={`every-lead-stats-bottom-border ${colorClassName}-underline`} />
    </a>
  );
}

EveryLeadCount.propTypes = {
  href: PropTypes.string,
  count: PropTypes.number,
  prevCount: PropTypes.number,
  icon: PropTypes.string.isRequired,
  colorClassName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  invertChangeColor: PropTypes.bool,
};

export default EveryLeadCount;
